function hideScroller() {
  actionbtn = $('.add-to-cart');
 var sub = $('#smsbump-form-55492');
    actionfromtop = actionbtn.offset().top +1730;
    subfromtop = $(window).scrollTop()+$(window).height();

  if (actionfromtop > subfromtop) { sub.hide(); }
  else { sub.show(); }
}

$(document).ready(function () {
    hideScroller(); 
    });
$(window).scroll(function () {
   hideScroller();   
});